import React, { useEffect, useState } from "react";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { DatePicker, Input, SelectPicker, Tag } from "rsuite";
import Pagination from "rsuite/Pagination";
import Swal from "sweetalert2";
import { APi } from "../../Api/";
import { exportAddAtom } from "../../Atoms/exportAdd.atom";
import ExportAdd from "../../Components/Common/ExportAdd";
import Filter from "../../Components/Common/Filter";
import Grid from "../../Components/Grid";
import Responsive from "../../Components/Responsive";
import TextImageIcon from "@rsuite/icons/TextImage";
import {
  checkPurpose,
  checkStatus,
  ConfirmationStatus,
  paymentType,
  SaleStatus,
  serviceTypes,
} from "../../Constants/types";
import validate from "../../Helpers/validate";
import { SaleModel } from "../../Models/SaleModels";
import AddEdit from "./AddEdit.component";
import { multiDataSet } from "./excel_data";
import moment from "moment";

import { saleSate } from "../../Atoms/sale.atom";
import { InvoiceService } from "../../Api/invoice.api";
import { agencyAtom } from "../../Atoms/agency.atom";
import { BASE_URL_INVOICE } from "../../Config/api.invoice";
import { SaleVoState } from "../../Atoms/SaleVo.atom";
import SaleVoModel from "../../Models/SaleVoModel";
import { createAPIEndpoint } from "../../Api/authenticated.requests";
import { ENDPOINTS } from "../../Api/enpoints";
import ResumeCard from "../../Components/ResumeCard";
import { BiTrip } from "react-icons/bi";
export default function SaleVo(props) {
  // STATE
  const [data, setdata] = useState([]);
  const [excel_data, setexcel_data] = useState([]);
  const [clients, setclients] = useState([]);
  const [clients2, setclients2] = useState([]);
  const [banks, setbanks] = useState([]);
  const [checkouts, setcheckouts] = useState([]);
  const [agentBookingFlights, setAgentBookingFlights] = useState([]);
  const [tags, setTags] = useState([]);
  const [providers, setproviders] = useState([]);
  const agency = useRecoilValue(agencyAtom);
  const [packages, setpackages] = useState([]);
  const [vols, setvols] = useState([]);

  const [totalCount, settotalCount] = useState(0);
  const [filterModel, setfilterModel] = useState({
    page: 1,
    take: 20,
    clientId: 0,
    status: 0,
    date: null,
    tagId: 0,
  });
  // --- add edit model ---
  const [error, setError] = useState("");
  const [model, setmodel] = useRecoilState(SaleVoState);

  // ATOMS
  const [state, setstate] = useRecoilState(exportAddAtom);
  // HELPERS
  const reset = () => {
    setmodel(new SaleVoModel());
    setError("");
  };
  // API CALLS
  const fetchClients = (q, forFilter = true) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Client, { q }, "/autocomplete")
        .customGet()
        .then((res) =>
          forFilter ? setclients(res.data) : setclients2(res.data)
        );
    }
  };
  const fetchBanks = (q) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Bank, { q }, "/autocomplete")
        .customGet()
        .then((res) => setbanks(res.data));
    }
  };
  const fetchAgentBookingFlights = (q) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(
        APi.ENDPOINTS.AgentBookingFlight,
        { q },
        "/autocomplete"
      )
        .customGet()
        .then((res) => setAgentBookingFlights(res.data));
    }
  };
  const fetchCheckouts = (q) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Checkout, { q }, "/autocomplete")
        .customGet()
        .then((res) => setcheckouts(res.data));
    }
  };

  const fetchProviders = (q) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Provider, { q }, "/autocomplete2")
        .customGet()
        .then((res) => setproviders(res.data));
    }
  };
  const fetchTags = (q) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Tag, { q }, "/autocomplete")
        .customGet()
        .then((res) => setTags(res.data));
    }
  };
  const fetch = (page) => {
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Order + "/VO",
      // +'/VO'
      {
        ...filterModel,

        date: filterModel.date
          ? moment(filterModel.date).format("DD MMM YYYY")
          : null,
        page: page ? page : filterModel.page,
      }
    )
      .fetchAll()
      .then((res) => {
        setdata(res.data.data);
        setstate((prev) => {
          return { ...prev, loading: false };
        });
        settotalCount(res.data.totalCount);
      })
      .catch((e) => {
        setError(e.Message);
        setstate((prev) => {
          return { ...prev, loading: false };
        });
      });
  };

  const save = () => {
    // let msg = validate(model, [
    //   { number: "Numéro" },
    //   { status: "Status" },
    //   { amount: "Montant" },
    //   { depositDate: "Date de Dépôt" },
    //   // { date: "Date" },

    //   { checkPurpose: "Type de Chéque" },
    //   // { clientId: "Client" },
    // ]);
    // if (msg) setError(msg);
    // else {
    console.log(model);

    setstate((prev) => {
      return { ...prev, loading: true };
    });
    let m = {
      ...model,
    };
    delete m.client;
    delete m.disponibility;
    delete m.package;
    console.log(m);

    if (model.id) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Order + "/VO")
        .update(m.id, m)
        .then((res) => {
          fetch();
          setstate((prev) => {
            return { ...prev, open: false, loading: false };
          });
          reset();
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Élément a été bien modifié !",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((e) => {
          setError(e.Message);
          setstate((prev) => {
            return { ...prev, loading: false };
          });
        });
    } else {
      APi.createAPIEndpoint(APi.ENDPOINTS.Order + "/VO")
        .create(m)
        .then((res) => {
          fetch();
          reset();
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Element a été bien ajouté !",
            showConfirmButton: false,
            timer: 1500,
          });
          setstate((prev) => {
            return { ...prev, open: false, loading: false };
          });
        })
        .catch((e) => {
          setError(e.Message);
          setstate((prev) => {
            return { ...prev, loading: false };
          });
        });
    }
    // }
  };
  const deleteAction = (id) => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Order + "/VO")
      .delete(id)

      .then((res) => {
        fetch();
        Swal.fire("Supprimé !", "", "success");
      })
      .catch((e) => setError(e.Message));
  };
  //
  const getBYId = (id) => {
    setError("");
    APi.createAPIEndpoint(APi.ENDPOINTS.Order + "/VO")
      .fetchById(id)
      .then((res) => {
        if (
          res.data.client &&
          !clients2.find((c) => c.id == res.data.client.id)
        ) {
          let arr = [...clients2];
          arr.unshift({ id: res.data.client.id, name: res.data.client.name });
          setclients2(arr);
        }

        setmodel((prev) => {
          let m = { ...res.data };
          m.date = m.date.substring(0, 10);
          let customer = { ...m.customer };
          // customer.expirationPassportDate =
          //   customer.expirationPassportDate.substring(0, 10);
          // customer.birthDate = customer.birthDate.substring(0, 10);
          return {
            ...m,

            customer,
          };
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchPackages = (q) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Package, { q }, "")
        .customGet()
        .then((res) => {
          setpackages(res.data.data);

          let _vols = res.data.data.reduce(
            (a, b) =>
              a.concat(
                b.disponibilities.map((el) => ({ packageId: b.id, ...el }))
              ),
            []
          );
          console.log(_vols);
          setvols(_vols.filter((d) => d.onStock));
        });
    }
  };
  // LIFE CYCLES
  useEffect(() => {
    fetch();
    fetchClients();
    fetchBanks();
    fetchCheckouts();
    fetchTags();
    fetchProviders();
    fetchAgentBookingFlights();
    fetchPackages();
  }, []);
  useEffect(() => {
    fetch();
  }, [filterModel.page, filterModel.take]);
  return (
    <div>
      <Filter search={() => fetch()}>
        {/* <Responsive m={6} l={2.4} xl={2.4} className="p-10">
          <label>Période: </label>
          {/* <DatePicker
            placement="bottomStart"
            value={filterModel.date}
            onChange={(date) =>
              setfilterModel((prev) => {
                return { ...prev, date };
              })
            }
            onSelect={(date) =>
              setfilterModel((prev) => {
                return { ...prev, date };
              })
            }
            block
          /> 
        </Responsive> */}
        <Responsive m={3} l={2.4} xl={2.4} className="p-10">
          <label>Recherche: </label>
          <Input
            placeholder="recherche"
            onChange={(q) => {
              setfilterModel((prev) => {
                return { ...prev, q };
              });
            }}
          />
        </Responsive>
        <Responsive m={6} l={4} xl={4} className="p-10">
          <label>Client: </label>
          <SelectPicker
            onSearch={(q) => fetchClients(q)}
            data={[{ label: "Tout", value: 0 }].concat(
              clients.map((c) => {
                return { label: c.name, value: c.id };
              })
            )}
            block
            noSearch
            value={filterModel.clientId}
            onSelect={(clientId) => {
              setfilterModel((prev) => {
                return { ...prev, clientId };
              });
            }}
          />
        </Responsive>
        <Responsive m={6} l={4} xl={4} className="p-10">
          <label>Voyage: </label>
          <SelectPicker
            onSearch={fetchPackages}
            data={[{ label: "Tout", value: 0 }].concat(
              packages.map((el) => {
                return { label: el.name, value: el.id };
              })
            )}
            block
            noSearch
            value={filterModel.packageId}
            onSelect={(packageId) => {
              setfilterModel((prev) => {
                return { ...prev, packageId };
              });
            }}
          />
        </Responsive>
        <Responsive m={6} l={2.4} xl={2.4} className="p-10">
          <label>Vol: </label>
          <SelectPicker
            data={[{ label: "Tout", value: 0 }].concat(
              vols
                ? vols.map((el) => {
                    return {
                      label: (
                        <div style={{ color: "#232323" }}>
                          {moment(el.date).format("DD MMM YYYY")} ({" "}
                          <i style={{ color: "#999" }}>
                            {packages &&
                              packages.find((l) => l.id == el.packageId) &&
                              packages.find((l) => l.id == el.packageId).name}
                          </i>
                          )
                        </div>
                      ),
                      value: el.id,
                    };
                  })
                : []
            )}
            block
            noSearch
            value={filterModel.disponibilityId}
            onSelect={(disponibilityId) => {
              // createAPIEndpoint(ENDPOINTS.Disponibility)
              //   .fetchById(disponibilityId)
              //   .then((res) => {
              //     console.log(res.data);
              //     setvol(res.data);
              //   });
              setfilterModel((prev) => {
                return { ...prev, disponibilityId };
              });
            }}
          />
        </Responsive>
        {/* <Responsive m={6} l={2.4} xl={2.4} className="p-10">
          <label>Status: </label>
          <SelectPicker
            searchable={false}
            data={[{ label: "Tout", value: 0 }].concat(checkStatus)}
            block
            noSearch
            value={filterModel.status}
            onSelect={(status) => {
              setfilterModel((prev) => {
                return { ...prev, status };
              });
            }}
          />
        </Responsive> */}

        {/* <Responsive m={6} l={3} xl={3} className="p-10">
          <label>Status du Paiement: </label>
          <SelectPicker
            searchable={false}
            data={[{ label: "Tout", value: 0 }].concat(SaleStatus)}
            block
            noSearch
            value={filterModel.status}
            onSelect={(status) => {
              setfilterModel((prev) => {
                return { ...prev, status };
              });
            }}
          />
        </Responsive> */}
        <Responsive m={6} l={4} xl={4} className="p-10">
          <label>Date du Vente: </label>
          <Input
            type="date"
            value={filterModel.date}
            onChange={(date) => {
              setfilterModel((prev) => {
                return { ...prev, date };
              });
            }}
          />
        </Responsive>
      </Filter>
      <ExportAdd
        excelData={multiDataSet(excel_data)}
        ActionOnClose={reset}
        nameExcel="saleVo"
        size="lg"
        save={save}
        handleExport={() => {
          APi.createAPIEndpoint(APi.ENDPOINTS.Order + "/GetOrerVosForExcel", {
            ...filterModel,
            date: filterModel.date
              ? moment(filterModel.date).format("DD MMM YYYY")
              : null,
            take: totalCount + 10,
            page: 1,
          })
            .fetchAll()
            .then((res) => {
              setexcel_data(res.data.data);
            })
            .catch((e) => setError(e.Message));
        }}
        AddComponent={
          <AddEdit
            checkouts={checkouts}
            tags={tags}
            fetchCheckouts={fetchCheckouts}
            fetchTags={fetchTags}
            providers={providers}
            fetchProviders={fetchProviders}
            error={error}
            banks={banks}
            fetchBanks={fetchBanks}
            clients={clients2}
            fetchClients={(q) => fetchClients(q, false)}
            fetchAgentBookingFlights={fetchAgentBookingFlights}
            agentBookingFlights={agentBookingFlights}
          />
        }
      />
      <div>
        <Responsive className="p-10" xs={6} s={6} m={6} l={3} xl={3}>
          <ResumeCard
            icon={<BiTrip />}
            notAmount
            text="Total Voyages"
            color="245,195,35"
            amount={totalCount}
          />
        </Responsive>
        <Responsive className="p-10" xs={6} s={6} m={6} l={3} xl={3}>
          <ResumeCard text="Total Vente" color="0,169,141" />
        </Responsive>
        <Responsive className="p-10" xs={6} s={6} m={6} l={3} xl={3}>
          <ResumeCard text="Total Remboursement" color="229,57,53" />
        </Responsive>
        <Responsive className="p-10" xs={6} s={6} m={6} l={3} xl={3}>
          <ResumeCard text="Total Commission" />
        </Responsive>
      </div>
      <Grid
        editAction={(id) => {
          getBYId(id);

          setstate((prev) => {
            return { ...prev, open: true };
          });
        }}
        deleteAction={deleteAction}
        actionKey="id"
        actions={[
          {
            label: "Confirmer",
            action: (dataKey) => {
              APi.createAPIEndpoint(
                ENDPOINTS.Order + "/VO/confirm/" + dataKey,
                {}
              )
                .customGet()
                .then((res) => fetch());
            },
            render: (v, id) => (
              <button
                style={{
                  color: "rgb(0,169,141)",
                  padding: "6px 10px",
                  fontSize: "12px",
                  background: "rgba(0,169,141,0.1)",
                  borderRadius: "4px",
                }}
              >
                {v}
              </button>
            ),
          },
          {
            label: "Refuser",
            action: (dataKey) => {
              APi.createAPIEndpoint(
                ENDPOINTS.Order + "/VO/revoke/" + dataKey,
                {}
              )
                .customGet()
                .then((res) => fetch());
            },
            render: (v, id) => (
              <button
                style={{
                  color: "rgb(229,57,53)",
                  padding: "6px 10px",
                  fontSize: "12px",
                  background: "rgba(229,57,53,0.1)",
                  borderRadius: "4px",
                }}
              >
                {v}
              </button>
            ),
          },
          {
            label: "Rendre En Attente",
            action: (dataKey) => {
              APi.createAPIEndpoint(
                ENDPOINTS.Order + "/Vo/pending/" + dataKey,
                {}
              )
                .customGet()
                .then((res) => fetch());
            },
            render: (v, id) => (
              <button
                style={{
                  color: "rgb(219,157,53)",
                  padding: "6px 10px",
                  fontSize: "12px",
                  background: "rgba(219,157,53,0.1)",
                  borderRadius: "4px",
                }}
              >
                {v}
              </button>
            ),
          },
        ]}
        // noAdvancedActions // for custom advanced actions

        columns={columns}
        rows={data}
      />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[10, 20, 50, 100]}
          limit={filterModel.take}
          activePage={filterModel.page}
          onChangePage={(page) => {
            window.scrollTo(0, 0);
            setfilterModel((prev) => {
              return { ...prev, page };
            });
          }}
          onChangeLimit={(take) => {
            console.log(take);
            setfilterModel((prev) => {
              return { ...prev, take, page: 1 };
            });
          }}
        />
      </div>
    </div>
  );
}

const columns = [
  {
    value: "package",
    name: "Voyage",
    render: (v) => (
      <b style={{ color: "#549f0a" }}>{v ? v.name.toUpperCase() : ""}</b>
    ),
  },
  {
    value: "client",
    name: "Client B2B",
    render: (v) => <a>{v ? v.name.toUpperCase() : ""}</a>,
  },
  {
    value: "customer",
    name: "Client B2C",
    render: (v) => (
      <a>
        {v ? v.name.toUpperCase() : ""}
        <br></br> <i style={{ color: "#aaa" }}>{v ? v.passportNumber : ""}</i>
      </a>
    ),
  },
  {
    value: "disponibility",
    name: "Vol",
    render: (c) =>
      c ? (
        <b
          style={{
            display: "flex",
            alignItems: "center",
            padding: "3px",

            borderRadius: "5px",
          }}
        >
          <img
            alt=""
            style={{ width: "30px", height: "30px", margin: "0 6px" }}
            src={c.airline ? c.airline.logo : ""}
          ></img>
          <b>
            {" "}
            <div style={{ color: "#232323" }}>
              {moment(c.date).format("DD MMM YYYY")}
            </div>
            <b style={{ color: "#888", fontWeight: "lighter" }}>
              {" "}
              {c.airline ? c.airline.name : ""}
            </b>
          </b>
        </b>
      ) : (
        <b>-</b>
      ),
  },
  {
    value: "confirmationStatus",
    name: "Etat",
    render: (v) => (
      <Tag
        color={
          v === 2 ? "violet" : v === 3 ? "green" : v === 4 ? "red" : "yellow"
        }
      >
        {ConfirmationStatus.find((el) => v === null || el.value === v)
          ? ConfirmationStatus.find((el) => v === null || el.value === v).label
          : ConfirmationStatus.find((el) => el.value === 1).label}
      </Tag>
    ),
  },
  // {
  //   value: "totalPrice",
  //   value2: "currency",
  //   value3: "commission",
  //   name: "Montant à payer",
  //   render: (v, v2, v3) => (
  //     <b style={{ color: "#53af50", fontSize: "18px" }}>
  //       {(v - v3).toFixed(3) + " "}
  //       <span style={{ color: "#888", fontSize: "11px", fontWeight: "400" }}>
  //         {v2}
  //       </span>
  //     </b>
  //   ),
  // },
  {
    value2: "currency",
    value: "commission",
    name: "Commission B2B",
    render: (v, v2) => (
      <b style={{ color: "#333", fontSize: "18px" }}>
        {v.toFixed(3) + " "}
        <span style={{ color: "#888", fontSize: "11px", fontWeight: "400" }}>
          {v2}
        </span>
      </b>
    ),
  },
  {
    value: "totalPrice",
    value2: "currency",

    name: "Prix Total",
    render: (v, v2) => (
      <b style={{ color: "#53af50", fontSize: "18px" }}>
        {v.toFixed(3) + " "}
        <span style={{ color: "#888", fontSize: "11px", fontWeight: "400" }}>
          {v2}
        </span>
      </b>
    ),
  },
  {
    value: "date",
    name: "Date",
    render: (v) => <strong>{moment(v).format("DD MMM YYYY")}</strong>,
  },
  {
    value: "notes",
    name: "Notes",
    render: (v) => {
      return (
        <div
          style={{
            maxWidth: "260px",
            padding: "10px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {v}
        </div>
      );
    },
  },
];
